import React, { Suspense } from 'react';
import { ApiRoutes } from '@bobex/react-core/routes/ApiRoutes';
import LoadingScreen from '@/components/LoadingScreen/LoadingScreen';
import { Button, Group } from '@mantine/core';

export default function AppSelection(): React.ReactElement {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Group justify="center" style={{ height: '100vh' }}>
        <Button
          component={'a'}
          href={ApiRoutes.REACT_APP_BASE_URL_DEV_FRONTEND() + '/backoffice-be/login'}
        >
          BackOffice BE
        </Button>
        <Button
          component={'a'}
          href={ApiRoutes.REACT_APP_BASE_URL_DEV_FRONTEND() + '/backoffice-nl/login'}
        >
          BackOffice NL
        </Button>
        <Button
          component={'a'}
          href={ApiRoutes.REACT_APP_BASE_URL_DEV_FRONTEND() + '/backoffice-ci/login'}
        >
          BackOffice CI
        </Button>
        <Button
          component={'a'}
          href={ApiRoutes.REACT_APP_BASE_URL_DEV_FRONTEND() + '/backoffice-vbk/login'}
        >
          BackOffice VBK
        </Button>
      </Group>
    </Suspense>
  );
}
